/**
 * DrawerHeader - Produktinfo im ProductActionDrawer
 * Plan 012: Merge Products + Channel Readiness
 */

import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui'
import { ReadinessActionBadge } from '../ReadinessActionBadge'
import type { ReadinessActionState } from '@/types/products'

interface DrawerHeaderProps {
  productName: string
  sku: string | null
  thumbnailUrl?: string | null
  state?: ReadinessActionState
  onClose: () => void
}

export function DrawerHeader({ productName, sku, thumbnailUrl, state, onClose }: DrawerHeaderProps) {
  const { t } = useTranslation()
  return (
    <div className="product-action-drawer-header flex items-start gap-3 p-4 border-b border-neutral-200 dark:border-neutral-700">
      {thumbnailUrl && (
        <img
          src={thumbnailUrl}
          alt=""
          aria-hidden="true"
          className="w-12 h-12 rounded object-cover flex-shrink-0"
        />
      )}
      <div className="flex-1 min-w-0">
        <h2
          id="product-action-drawer-title"
          className="text-base font-semibold text-neutral-900 dark:text-neutral-100 truncate"
        >
          {productName}
        </h2>
        {sku && <p className="text-xs text-neutral-500 mt-0.5">{t('products.drawer_sku_label')} {sku}</p>}
        {state && <div className="mt-1.5"><ReadinessActionBadge state={state} /></div>}
      </div>
      <Button variant="ghost" size="sm" onClick={onClose} aria-label={t('products.drawer_close')}>
        <X className="w-4 h-4" />
      </Button>
    </div>
  )
}
